export const SFH_ALLOWED_STATES = [
  { code: 'TX', name: 'Texas' },
  { code: 'CA', name: 'California' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'OR', name: 'Oregon' },
  { code: 'CO', name: 'Colorado' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'WA', name: 'Washington' },
  { code: 'MO', name: 'Missouri' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NY', name: 'New York' },
  { code: 'FL', name: 'Florida' },
  { code: 'IL', name: 'Illinois' },
];

export const isStateAllowedForSfh = (stateRegion) =>
  SFH_ALLOWED_STATES.some(
    (state) => state.code === String(stateRegion || '').toUpperCase(),
  );
